import tw from "tailwind-styled-components";
import { MdClose } from "react-icons/md";
import moment from "moment";
import { ActionSection, ScrollableContent, SideCancelBtn, SubmitBtn } from "../Styles/InputStyles";
import { capitalizeFirstLetter, getDueTypeLabel } from "../../helpers";
import { Formik, Form, Field, ErrorMessage } from "formik";
import * as Yup from "yup";
import { FaRegBuilding } from "react-icons/fa";
import Images from "../../Images";

const ViewDetails = ({
    setShowDueDetails,
    selectedData,
    setIsEditDues,
    showNotesModal,
    setShowNotesModal,
    handleSaveNotes,
    addEditRemarkLoading,
    addEditRemarkMutate,
    canMarkPaymentPaid
}) => {
    const onClose = () => {
        setShowDueDetails(false);
        setShowNotesModal(false)
    };

    const desc = selectedData?.description ? selectedData?.description : selectedData?.title;

    return (
        <>
            <Container>
                <Header>
                    <Title>Due Details</Title>
                    <button onClick={onClose}>
                        <MdClose color="white" size={24} />
                    </button>
                </Header>
                {/* <ProfileSection className="flex justify-between">
                    <UserInfo>
                        <span className="font-medium mb-0">
                            {capitalizeFirstLetter(selectedData?.tenantName)}
                        </span>
                        <span className="text-sm text-gray-600">
                            {'#' + selectedData?.roomNum + ", " + selectedData?.flatName + ", " + selectedData?.propertyName}
                            {capitalizeFirstLetter('#' + selectedData?.inventoryName)}
                        </span>
                    </UserInfo>
                    <div className="flex flex-col gap-0">
                        <span className='text-gray-500 text-sm'>{'Amount'}</span>
                        <span className='text-xl font-semibold text-gray-700'>{'₹' + selectedData?.balance}</span>
                    </div>
                </ProfileSection> */}
                <ProfileSection className="px-4 py-3 flex items-center justify-between">
                    <div className="flex items-center gap-2">
    
                        <div className="w-10 h-10 rounded-full bg-gray-50 flex items-center justify-center">
                            <UserImage
                              src={Images.Avatar}
                              alt={`Tenant Profile`}
                            />

                        </div>
                        <div className="flex flex-col">
                            <p className="text-md font-medium text-gray-800">
                                {/* {'#' + selectedData?.roomNum + ", " + selectedData?.flatName + ", " + selectedData?.propertyName} */}
                                {capitalizeFirstLetter(selectedData?.tenantName || "")}
                            </p>
                            <p className="text-xs text-gray-400">
                                {capitalizeFirstLetter(selectedData?.inventoryName || "")}
                            </p>
                        </div>
    
                    </div>
    
                    <div className="text-right">
                        <p className="text-xs text-gray-400">Amount</p>
                        <p className="text-lg font-bold text-gray-600">
                            ₹{selectedData?.balance || 0}
                        </p>
                    </div>
                </ProfileSection>
                <Content>
                    <ScrollableContent>
                        <Wrapper>
                            <BtnWrapper>
                                <SectionTitle>Due Details</SectionTitle>
                                {/* {canMarkPaymentPaid &&
                                    <EditButton
                                        title="Edit Basic Detail"
                                        onClick={() => {
                                            setShowDueDetails(false);
                                            setIsEditDues(true);
                                        }}
                                    >
                                        Edit
                                    </EditButton>
                                } */}
                            </BtnWrapper>
                            <Section>
                                <Row className="mb-3">
                                    <FlexCol>
                                        <Label>Type</Label>
                                        <Value>{selectedData?.type ? getDueTypeLabel((selectedData?.type)) : selectedData?.title}</Value>
                                    </FlexCol>
                                    <FlexCol>
                                        <Label>Duration</Label>
                                        <Value>
                                            {selectedData?.rentStartDate && selectedData?.rentEndDate
                                                ? `${moment(selectedData.rentStartDate).format('DD, MMM YY')} - ${moment(
                                                    selectedData.rentEndDate
                                                ).format('DD, MMM YY')}`
                                                : '-'}
                                        </Value>

                                    </FlexCol>

                                </Row>
                                <Row className="mb-3">
                                    <FlexCol>
                                        <Label>Due Date</Label>
                                        <Value>{moment(selectedData?.dueDate).format("DD, MMM YYYY")}</Value>
                                    </FlexCol>
                                    <FlexCol>
                                        <Label>Created At</Label>
                                        <Value>{moment(selectedData?.createdAt).format("DD, MMM YYYY")}</Value>
                                    </FlexCol>
                                </Row>
                                <div className="flex flex-col mb-1">
                                    <FlexCol>
                                        <Label>Description</Label>
                                        <Value>{desc}</Value>
                                    </FlexCol>
                                    {/* <div className="mt-2">
                                        <FlexCol >
                                            <div className="flex justify-between">
                                                <Label>Notes</Label>
                                                <EditButton
                                                    title={selectedData?.remarks ? "Edit Notes" : "Add Notes"}
                                                    onClick={() => {
                                                        setShowNotesModal(true);
                                                    }}
                                                >
                                                    {selectedData?.remarks ? "Edit Notes" : "Add Notes"}
                                                </EditButton>
                                            </div>
                                            <Value>{selectedData?.remarks || "--"}</Value>
                                        </FlexCol>
                                    </div> */}
                                </div>

                            </Section>

                            <BtnWrapper>
                                <SectionTitle>Payment Summary</SectionTitle>
                            </BtnWrapper>
                            <Section>
                                <Row>
                                    <Label>Total Due</Label>
                                    <Value className='ml-auto'>{'₹' + selectedData?.amount}</Value>
                                </Row>
                                <Row className="mb-2 border-b border-dashed">
                                    <Label>Paid</Label>
                                    <Value className='ml-auto'>{'₹' + (Number(selectedData?.amount) - Number(selectedData?.balance))}</Value>
                                </Row>
                                <Row>
                                    <Label>Balance</Label>
                                    <Value className="ml-auto">{'₹' + selectedData?.balance}</Value>
                                </Row>
                            </Section>
                        </Wrapper>
                    </ScrollableContent>
                </Content>
            </Container>

            {/* Notes Modal */}
            {showNotesModal && (
                <NotesModal
                    selectedData={selectedData}
                    setShowNotesModal={setShowNotesModal}
                    setShowDueDetails={setShowDueDetails}
                    handleSaveNotes={handleSaveNotes}
                    addEditRemarkLoading={addEditRemarkLoading}
                    addEditRemarkMutate={addEditRemarkMutate}
                />
            )}
        </>
    );
};

// Notes Modal Component
const NotesModal = ({
    selectedData,
    setShowNotesModal,
    setShowDueDetails,
    handleSaveNotes,
    addEditRemarkMutate,
    addEditRemarkLoading

}) => {

    const initialValues = {
        remarks: selectedData?.remarks || "",
        id: selectedData?.tenantId
    };

    const validationSchema = Yup.object().shape({
        remarks: Yup.string()
            .required("Remarks is required")
            .max(500, "Remarks must be 500 characters or less")
    });

    const onSubmit = (values) => {
        addEditRemarkMutate({
            remarks: values.remarks,
            id: values.id
        });
        // setShowNotesModal(false);
        // setShowDueDetails(true);
    };

    const onClose = () => {
        setShowNotesModal(false);
        setShowDueDetails(true);
    };

    return (
        <ModalContainer>
            <Container>
                <Header>
                    <Title>  {selectedData?.remarks ? "Edit Notes" : "Add Notes"}</Title>
                    <button onClick={onClose}>
                        <MdClose color="white" size={24} />
                    </button>
                </Header>
                <Content>
                    <ScrollableContent>
                        <Wrapper>

                            <Formik
                                initialValues={initialValues}
                                validationSchema={validationSchema}
                                onSubmit={onSubmit}
                            >
                                {({ isSubmitting }) => (
                                    <StyledForm>
                                        {/* <ModalBody> */}
                                        <Field
                                            as="textarea"
                                            name="remarks"
                                            placeholder="Enter your remarks here..."
                                            className="w-full p-2 border border-gray-300 rounded-md h-32"
                                        />
                                        <ErrorMessage
                                            name="remarks"
                                            component="div"
                                            className="text-red-500 text-sm mt-1"
                                        />
                                        {/* </ModalBody> */}

                                        <ActionSection>
                                            <SideCancelBtn type="button" onClick={() => {

                                                onClose();
                                            }
                                            }>
                                                Cancel
                                            </SideCancelBtn>
                                            <SubmitBtn type="submit" disabled={addEditRemarkLoading}>
                                                {addEditRemarkLoading ? "Submiting..." : "Submit"}
                                            </SubmitBtn>
                                        </ActionSection>
                                    </StyledForm>
                                )}
                            </Formik>
                        </Wrapper>
                    </ScrollableContent>
                </Content>
            </Container>
        </ModalContainer>
    );
};

// Styled components for the modal
const ModalContainer = tw.div`fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50`;
// const ModalBody = tw.div`p-4`;
const StyledForm = tw(Form)`flex flex-col`;
const Header = tw.div`flex items-center justify-between bg-[#26A69A] py-4 px-4`;
const Wrapper = tw.div`grid gap-2 my-0`;
const Container = tw.div`bg-white w-full h-full min-h-[100vh] flex flex-col`;
const Content = tw.div`p-4 flex flex-col gap-4`;
const Title = tw.h1`text-lg md:text-xl font-medium text-center text-white`;
const Section = tw.div`border border-gray-200 p-2 rounded-lg mb-3`;
const SectionTitle = tw.h2`text-base font-medium text-gray-600 flex justify-between items-center`;
const Row = tw.div`grid grid-cols-2 py-1 md:p-1`;
const Label = tw.label`text-sm text-gray-400 font-normal`;
const Value = tw.span`text-gray-600 text-md`;
const BtnWrapper = tw.div`w-full flex items-center justify-between`;
const FlexCol = tw.div`flex flex-col gap-0.5`;
const UserInfo = tw.div`flex flex-col`;
const ProfileSection = tw.div`flex items-center gap-3 bg-gray-100 px-4 p-4`;
const EditButton = tw.button`text-sm px-1 py-0.5 items-center flex justify-between text-primary-color underline`;
const UserImage = tw.img`w-12 h-10 rounded-full shadow-lg`;

export default ViewDetails;